import {
	mergeFlags,
	movePriceStandard,
	createNumericRagings,
	moveFlagsAfterImage,
	moveAvailabilityToPrices,
	moveAddToFavorites,
	moveDescriptionToTop,
	handleDetailBtn,
	handleBtnInput,
} from '../modules/productCard'
import {
	createElement,
	createProductBlockLinks,
	overrideSplitMenu,
	handleLastVisited,
} from '../modules/globalFunctions'
import { blogOnHomepage } from '../modules/blog'
import {
	moveInstagram,
	createMirandaSignature,
	separateFooterBottom,
	createPaymentMethods,
	addCopyrigthSignToFooterBottom,
} from '../modules/footer'
import {
	moveCategoryBannersIntoProducts,
	handleCheckedFilters,
	addIDToDescription,
	changeTextInPagination,
	fixPaginationScroll,
} from '../modules/category'
import { moveTabsOnDetail } from '../modules/productDetail'
import {
	moveCartHeader,
	createCartFooter,
	makePriceTotalSeparateTd,
	freeShippingOnExtraDelivery,
	changeBtnToHeadingCheckoutBox,
	moveExtraDeliveryToSidebar,
	handleStepBack,
	changeTextInOrderBtn,
	getPaymentOnInvoice,
} from '../modules/cart'

import { createMenuLevel2Wrap } from '../modules/header'

import {
	moveNewsletterBeforeFooter,
	changeNewsletterHeading,
	createNewsletterPerex,
	addImgToNewsletter,
} from '../modules/newsletter'

/**
 * Handles the product card.
 * Define all functions that should be used on a single product card.
 * @param {*} product Product card element
 */
const handleProductCard = (product) => {
	mergeFlags(product)
	movePriceStandard(product)
	moveDescriptionToTop(product)
	handleDetailBtn(product)
	handleBtnInput(product)
}

/**
 * Handles all product cards.
 * Selects all product cards and calls the handleProductCard function on each of them.
 */
const PACKAGE_API_URL = 'https://tgs-prod.axfone.eu/products/package'

const applyPackageStep = (input, step) => {
	if (input.dataset.packageStep) return
	input.setAttribute('step', step)
	input.dataset.packageStep = step
	input.addEventListener('change', () => {
		const s = parseInt(input.step) || 1
		const min = parseInt(input.min) || 1
		const raw = parseInt(input.value) || min
		input.value = raw <= min ? min : Math.ceil((raw - min) / s) * s + min
		console.log(
			`package step change: value=${input.value} step=${s} min=${min}`
		)
	})
}

const fetchPackageSizesForInputs = async (guidInputMap) => {
	if (!guidInputMap.size) return
	const formData = new FormData()
	for (const guid of guidInputMap.keys()) formData.append('productGuid[]', guid)
	try {
		const response = await fetch(PACKAGE_API_URL, {
			method: 'POST',
			body: formData,
		})
		const data = await response.json()
		console.log('fetchPackageSizesForInputs response:', data)
		for (const [guid, packageSize] of Object.entries(data)) {
			const step = parseInt(packageSize)
			if (!step || step <= 1) continue
			const input = guidInputMap.get(guid)
			if (!input) continue
			applyPackageStep(input, step)
			console.log(`applied step=${step} for guid=${guid}`)
		}
	} catch (e) {
		console.error('Error fetching package sizes:', e)
	}
}

const fetchPackageSizes = (products) => {
	const map = new Map()
	for (const product of products) {
		const guid = product
			.querySelector('[data-micro-identifier]')
			?.getAttribute('data-micro-identifier')
		const input = product.querySelector('.p-tools input[name="amount"]')
		if (guid && input) map.set(guid, input)
	}
	fetchPackageSizesForInputs(map)
}

const fetchCartWidgetPackageSizes = () => {
	const map = new Map()
	for (const item of document.querySelectorAll(
		'.cart-widget-product[data-micro-identifier]'
	)) {
		const guid = item.getAttribute('data-micro-identifier')
		const input = item.querySelector('input[name="amount"]')
		if (guid && input) map.set(guid, input)
	}
	fetchPackageSizesForInputs(map)
}

const fetchCartTablePackageSizes = () => {
	const map = new Map()
	for (const row of document.querySelectorAll('tr[data-micro-identifier]')) {
		const guid = row.getAttribute('data-micro-identifier')
		const input = row.querySelector('input[name="amount"]')
		if (guid && input) map.set(guid, input)
	}
	fetchPackageSizesForInputs(map)
}

const handleAllProducts = () => {
	const allProducts = document.querySelectorAll('.products-block .product')
	for (const product of allProducts) {
		handleProductCard(product)
	}
	fetchPackageSizes(allProducts)
}
handleAllProducts()
document.addEventListener('ShoptetDOMContentLoaded', handleAllProducts)

fetchCartWidgetPackageSizes()
document.addEventListener(
	'ShoptetDOMCartContentLoaded',
	fetchCartWidgetPackageSizes
)

fetchCartTablePackageSizes()
document.addEventListener(
	'ShoptetDOMCartContentLoaded',
	fetchCartTablePackageSizes
)

const convertProductBlockIntoSlider = (block) => {
	const slickSettings = {
		slidesToShow: 4,
		infinite: false,
		dots: false,
		responsive: [
			{
				breakpoint: 1100,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					dots: false,
					arrows: false,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1.1,
					dots: false,
					arrows: false,
				},
			},
		],
	}
	$(block).slick(slickSettings)
}

const footer = document.querySelector('footer')

moveInstagram()

const handleBrandsBanner = () => {
	const brandsBanner = document.querySelector('footer .brands-wrapper')
	if (brandsBanner) {
		const parentElement = brandsBanner.closest('.banner').parentElement
		const brandsInner = brandsBanner.querySelector('.brands-inner')
		if (parentElement) parentElement.remove()
		footer.before(brandsBanner)
		if (brandsInner)
			$(brandsInner).slick({
				slidesToShow: 5.5,
				infinite: false,
				dots: false,
				responsive: [
					{
						breakpoint: 1100,
						settings: {
							slidesToShow: 4.5,
						},
					},
					{
						breakpoint: 900,
						settings: {
							slidesToShow: 3.5,
						},
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 2.5,
							dots: true,
							arrows: false,
						},
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1.7,
							dots: true,
							arrows: false,
						},
					},
				],
			})
	}
}
handleBrandsBanner()
moveNewsletterBeforeFooter()
changeNewsletterHeading()
createNewsletterPerex()
addImgToNewsletter()
createMirandaSignature()
createPaymentMethods()
separateFooterBottom()
addCopyrigthSignToFooterBottom()

if (footer) {
	if (!document.querySelector('.footer-left')) {
		const footerLeft = createElement('div', ['footer-left'])
		const siteName = document.querySelector('.footer-rows > .site-name')
		const footerRows = document.querySelector('.footer-rows')
		const customContact = document.querySelector('.custom-footer__contact')
		const footerIcons = document.querySelector('.footer-icons')

		if (siteName) footerLeft.appendChild(siteName)
		if (customContact) {
			const contactUl = customContact.querySelector('.contact-box ul')
			if (
				contactUl &&
				typeof adresaVPaticce !== 'undefined' &&
				adresaVPaticce !== null
			) {
				const addressLi = createElement('li', [])
				if (typeof odkazKAdrese !== 'undefined' && odkazKAdrese !== null) {
					addressLi.innerHTML = `<span class="address"><a href=${odkazKAdrese} target="_blank"> ${adresaVPaticce}</a></span>`
				} else {
					addressLi.innerHTML = `<span class="address"><a> ${adresaVPaticce}</a></span>`
				}
				contactUl.appendChild(addressLi)
			}
			footerLeft.appendChild(customContact)
		}
		if (footerIcons) footerLeft.appendChild(footerIcons)
		footerRows.prepend(footerLeft)
	}
}

// LAST VISITED
document.addEventListener('dkLabLastVisitedProductsLoaded', handleLastVisited)

// HOMEPAGE
if (dataLayer[0].shoptet.pageType === 'homepage') {
	createProductBlockLinks()
	const whySocialsPlaceholder = document.querySelector(
		'.why__wrapper .socials-placeholder'
	)
	const footerIcons = document.querySelector('.footer-icons')
	if (whySocialsPlaceholder && footerIcons) {
		whySocialsPlaceholder.replaceWith(footerIcons.cloneNode(true))
	}
	const whyItems = document.querySelectorAll('.why__item:not(.socials)')
	for (const item of whyItems) {
		const heading = item.querySelector('h5')
		if (heading) {
			heading.addEventListener('click', () => {
				item.classList.toggle('active')
			})
		}
	}
}

// KATEGORIE
if (dataLayer[0].shoptet.pageType === 'category') {
	moveCategoryBannersIntoProducts(5, 9)
	document.addEventListener('ShoptetDOMContentLoaded', () => {
		moveCategoryBannersIntoProducts(5, 9)
	})
	changeTextInPagination(
		window.language === 'cs' ? 'Zpět nahoru' : 'Späť hore',
		window.language === 'cs' ? 'ZOBRAZIT další' : 'ZOBRAZIŤ ďalšie'
	)

	// not used on this project as it uses the plug-in Filtry+
	// handleCheckedFilters()
	addIDToDescription()
	document.addEventListener('ShoptetDOMContentLoaded', () => {
		changeTextInPagination(
			window.language === 'cs' ? 'Zpět nahoru' : 'Späť hore',
			window.language === 'cs' ? 'ZOBRAZIT další' : 'ZOBRAZIŤ ďalšie'
		)
		// handleCheckedFilters()
		addIDToDescription()
	})
	fixPaginationScroll()
}

// adding text to active filters done by the plugin Filtry+
document.addEventListener('dkLabFiltersChanged', () => {
	if (window.innerWidth > 767) {
		const dkLabFiltersButtonIn = document.querySelector(
			'.dkLab-filters-button__in'
		)
		if (dkLabFiltersButtonIn) {
			const activeFiltersTitle = createElement(
				'strong',
				['active-title'],
				window.language === 'cs' ? 'Vybrané filtry: ' : 'Vybrané filtre:'
			)
			dkLabFiltersButtonIn.prepend(activeFiltersTitle)
		}
	}
})

// PRODUCT DETAIL
if (dataLayer[0].shoptet.pageType === 'productDetail') {
	moveTabsOnDetail()
	const productsRelated = document.querySelector('.products-related')
	if (productsRelated) {
		convertProductBlockIntoSlider(productsRelated)
	}
	console.log('Product detail page loaded')

	const fetchDetailPackageSize = async () => {
		const guid = document
			.querySelector('meta[itemprop="identifier"]')
			?.getAttribute('content')
		console.log('Product GUID:', guid)
		if (!guid) return
		const input = document.querySelector('input[name="amount"]')
		console.log('Amount input found:', input)
		if (!input) return

		fetchPackageSizesForInputs(new Map([[guid, input]]))
	}
	fetchDetailPackageSize()
}

// CART
if (document.body.classList.contains('ordering-process')) {
	moveCartHeader()
	createCartFooter()
	moveExtraDeliveryToSidebar()
	changeTextInOrderBtn(
		window.language === 'cs'
			? 'pokračovat v objednávce'
			: 'pokračovať v objednávke'
	)
	makePriceTotalSeparateTd()
	freeShippingOnExtraDelivery()
	changeBtnToHeadingCheckoutBox()
	handleStepBack()
	const handleFreeRecapitulation = () => {
		setTimeout(() => {
			const recapItemPrices = document.querySelectorAll(
				".recapitulation-single span[data-testid='recapItemPrice']"
			)
			if (recapItemPrices.length) {
				recapItemPrices.forEach((price) => {
					if (price.innerText.toUpperCase().includes('ZDARMA')) {
						price.classList.add('for-free')
					} else if (price.innerText == '0 Kč') {
						price.classList.add('for-free')
						price.innerText = 'ZDARMA'
					} else {
						price.classList.remove('for-free')
					}
				})
			}
		}, 100)
	}
	handleFreeRecapitulation()
	document.addEventListener(
		'ShoptetShippingMethodUpdated',
		handleFreeRecapitulation
	)
	document.addEventListener(
		'ShoptetBillingMethodUpdated',
		handleFreeRecapitulation
	)
	// PLATBA NA FAKTURU
	if (dataLayer[0].shoptet.pageType === 'billingAndShipping')
		getPaymentOnInvoice()

	document.addEventListener('ShoptetDOMCartContentLoaded', () => {
		moveCartHeader()
		createCartFooter()
		makePriceTotalSeparateTd()
		freeShippingOnExtraDelivery()
		changeBtnToHeadingCheckoutBox()
		moveExtraDeliveryToSidebar()
		handleStepBack()
		changeTextInOrderBtn(
			window.language === 'cs'
				? 'pokračovat v objednávce'
				: 'pokračovať v objednávke'
		)
		if (dataLayer[0].shoptet.pageType === 'billingAndShipping')
			getPaymentOnInvoice()
	})
}

if (document.body.classList.contains('customer-page')) {
	const customerOrders = document.querySelector('table.customer-orders')
	if (customerOrders) {
		const orderHeader = customerOrders.querySelector('thead tr')
		if (orderHeader) {
			const cell = document.createElement('th')
			cell.innerText = window.language === 'cs' ? 'Faktura' : 'Faktúra'
			orderHeader.appendChild(cell)
		}
		const orderRows = customerOrders.querySelectorAll('tbody tr')
		const orderIDs = new FormData()
		for (let i = 0; i < orderRows.length; i++) {
			const row = orderRows[i]
			const cell = document.createElement('td')
			const mobileSpan = document.createElement('span')
			mobileSpan.classList.add('client-table-heading')
			mobileSpan.innerText = window.language === 'cs' ? 'Faktura' : 'Faktúra'
			cell.appendChild(mobileSpan)
			let orderNumber = row.querySelector('a[data-testid="linkCustomerOrder"]')
			orderIDs.append('orderID[]', orderNumber.innerText.trim())
		}
		fetch('https://tgs-prod.axfone.eu/invoice/list', {
			method: 'POST',
			body: orderIDs,
		})
			.then((response) => {
				if (response.ok) {
					response.json().then((data) => {
						Object.keys(data).forEach((orderID) => {
							const hash = data[orderID]
							if (!hash) return
							console.log('orderID', orderID, 'hash', hash)
							const orderRow = Array.from(orderRows).find((row) => {
								const link = row.querySelector(
									'a[data-testid="linkCustomerOrder"]'
								)
								return link && link.innerText.trim() === orderID
							})
							if (!orderRow) return
							const cell = document.createElement('td')
							const mobileSpan = document.createElement('span')
							mobileSpan.classList.add('client-table-heading')
							mobileSpan.innerText =
								window.language === 'cs' ? 'Faktura' : 'Faktúra'
							cell.appendChild(mobileSpan)
							const link = document.createElement('a')
							link.href = `https://tgs-prod.axfone.eu/invoice?orderID=${hash}`
							link.target = '_blank'
							link.innerText =
								window.language === 'cs' ? 'Zobrazit' : 'Zobraziť'
							cell.appendChild(link)
							orderRow.appendChild(cell)
						})
					})
				}
			})
			.catch((error) => {
				console.error('Error fetching invoice data:', error)
			})
	}
}

// const registerForm = document.querySelector('#register-form')
// if (registerForm) {
// 	const companyShopping = registerForm.querySelector('.company-shopping')
// 	if (companyShopping) companyShopping.classList.add('unveiled', 'js-hidden')
// 	const companyShoppingInput = registerForm.querySelector('.company-shopping input#company-shopping')
// 	if (companyShoppingInput) companyShoppingInput.setAttribute('checked', true)
// 	const companyInfo = registerForm.querySelector('#company-info')
// 	if (companyInfo) companyInfo.classList.add('visible')

// 	registerForm.addEventListener('submit', async (e) => {
// 		e.preventDefault()
// 		e.stopPropagation()
// 		fetch('https://tgs-prod.axfone.eu/customercheck?ico=' + registerForm.querySelector('#companyId').value)
// 			.then((response) => response.json())
// 			.then((data) => {
// 				console.log(data)
// 				if (data.success) {
// 					registerForm.innerHTML = `
// 						<p>Zadané IČO je již v našem systému zaregistrováno. Prosím kontaktujte <a href="/kontakty/">naši zákaznickou podporu</a> pro další informace.</p>
// 					`
// 					return
// 				} else {
// 					registerForm.submit()
// 					console.log('registrace povolena!')
// 				}
// 			})
// 			.catch((error) => {
// 				console.error('Error:', error)
// 			})
// 	})
// }
